import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "../../../redux/store";
import { setSelectedBookmarks } from "../../../redux/pdSearchSlice";

type UpcomingEvent = {
    cpabcMeeting: string | number;
    [key: string]: unknown;
};

type BookmarkIconProps = UpcomingEvent;

const STORAGE_KEY = "ngStorage-bookmarks";

export default function BookmarkIcon(props: BookmarkIconProps) {
    const dispatch = useDispatch<AppDispatch>();

    const selectedBookmarks = useSelector(
        (state: RootState) => state.pdSearch.selectedBookmarks
    ) as UpcomingEvent[];

    useEffect(() => {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return;

            const storageBookmarks = JSON.parse(raw) as UpcomingEvent[];
            if (Array.isArray(storageBookmarks)) {
                dispatch(setSelectedBookmarks(storageBookmarks));
            }
        } catch (error) {
            console.log((error as Error).name);
        }
    }, [dispatch]);

    const arrayIncludesInObj = <T extends Record<string, unknown>>(
        arr: T[],
        key: keyof T,
        valueToCheck: unknown
    ) => arr.some((value) => value[key] === valueToCheck);

    const bookmark = (item: UpcomingEvent) => {
        let next = [...(selectedBookmarks ?? [])];

        if (arrayIncludesInObj(next, "cpabcMeeting", item.cpabcMeeting)) {
            next = next.filter((course) => course.cpabcMeeting !== item.cpabcMeeting);
        } else {
            next = [...next, item];
        }

        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        } catch (error) {
            console.log((error as Error).name);
        }

        dispatch(setSelectedBookmarks(next));
    };

    const isActive = arrayIncludesInObj(
        selectedBookmarks ?? [],
        "cpabcMeeting",
        props.cpabcMeeting
    );

    return (
        <div
            className={"event-card__bookmark-icon" + (isActive ? " active" : "")}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                bookmark(props);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    bookmark(props);
                }
            }}
            aria-pressed={isActive}
            aria-label={isActive ? "Remove bookmark" : "Add bookmark"}
        >
            <svg className="icon" width={18} height={18} aria-hidden="true">
                {isActive 
                    ?
                    <use xlinkHref="/images/icons/sprite.svg#iconBookmarkSolid" />
                    :
                    <use xlinkHref="/images/icons/sprite.svg#iconBookmarkRegular" />
                }
            </svg>
        </div>
    );
}
